import { ResearchGrantMatch } from '../../models/research.models';
import { FormatAwardLine, FormatClosingLine } from '../grant-finder/grant-card.component';

/**
 * Search everything (Task 24) needs one meta line per row, and only the
 * grant case needs new composition — `GrantCardComponent` has no equivalent
 * single-line formatter of its own (it renders Award and Closes as two
 * separate fact rows, never joined into one string), unlike
 * `PersonCardComponent.RoleLine`/`PersonRoleLine` and
 * `JobCardComponent.MetaLine`/`FormatJobMeta`, which are already exactly the
 * single-line shape a search result row needs and are imported directly by
 * `search-page.component.ts` rather than wrapped here.
 *
 * `FormatAwardLine`/`FormatClosingLine` (grant-card.component.ts) are reused
 * as-is — this is a composition of those two pure formatters, not a
 * reimplementation of either.
 */
export function FormatGrantMeta(grant: Pick<ResearchGrantMatch, 'grantor' | 'awardFloorUSD' | 'awardCeilingUSD' | 'closingDate' | 'closingIsRolling'>): string {
    const parts = [grant.grantor, FormatAwardLine(grant), FormatClosingLine(grant)].filter((v): v is string => Boolean(v));
    return parts.join(' · ');
}
